import React from "react";
import { useHistory } from "react-router-dom";
import InputSelectMobile from "../../../../components/InputSelectMobile";
import useAuthData from "../../../../hook/useAppData";
import { getProjectsByClient } from "../../service";
import { TitleMobile } from "../components/TitleMobile";

export function SelectClientAndProject({ listClient, project, setProject, setPages, points, setPoints }) {
  const { token } = useAuthData();
  const history = useHistory();

  async function getProject(value) {
    const res = await getProjectsByClient(token, value);
    setProject(res);
  }

  return (
    <>
      <TitleMobile onClick={() => history.goBack()} title="Apontamento de Horas" />
      <div className="w-screen h-4/6 flex-col bg-primary -ml-8 p-8  flex items-center shadow justify-evenly">
        <InputSelectMobile
          className=""
          name={""}
          label="Clientes"
          list={listClient}
          value={points?.clientId}
          onChange={(e) => {
            setPoints({ ...points, clientId: +e.target.value });
            getProject(e.target.value);
          }}
        />
        <InputSelectMobile
          name={""}
          label="Projetos"
          list={project}
          value={points?.projectId}
          onChange={(e) => setPoints({ ...points, projectId: +e.target.value })}
        />
      </div>
      <div className="w-full h-1/6 flex justify-center items-center">
        <button
          className="bg-primary h-20 rounded-2xl w-full mx-3 text-2rem font-familyPoppins font-medium shadow-2xl"
          onClick={() => setPages("confirm")}
        >
          Próximo
        </button>
      </div>
    </>
  );
}
